import React from 'react';
import styled from 'styled-components';
import ShenideSho from '../assets/login_images/ShenideSho.svg';

const LoadingCss = styled.div`
width: 100%;
height: 80vh;
.background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  backdrop-filter: blur(3px);
  animation: backdrop-animation 1s ease-in-out infinite 0s forwards !important;
}
@keyframes backdrop-animation {
        0%  {
              backdrop-filter: blur(0px);     
            }
        50% {
              backdrop-filter: blur(3px);     
            }
        100%{
              backdrop-filter: blur(0px);     
            }
    }

.loader{
  background-color: #f7f7f7;
  z-index: 800;
  width: 150px;
  height: 100px;
  position: fixed;
  top: calc(50% - 100px);
  left: calc(50% - 100px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0 2px 8px 0 #00000014;
  padding: 25px 25px;
  border-radius: 1rem;
}
.loader img{
  width: 90%;
  margin: 0.5rem auto;
}



/* loading animation*/
.lds-ellipsis {
  margin: 10px auto 0;
  display: inline-block;
  position: relative;
  width: 80px;
  height: 20px;
}
.lds-ellipsis div {
  position: absolute;
  top: 3.5px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--primary-1);
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0) translate(-24px, 0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0) translate(24px, 0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}

`;

export const LoadingWLogo = () => {
    return (
        <LoadingCss>
            <div className="background">
            </div>
            <div className="loader">
              {/* <img src={ShenideSho} alt="ShenideSho"/> */}
              <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
            </div>
        </LoadingCss>
    );
}